import { render, staticRenderFns } from "./EffectFields.vue?vue&type=template&id=338c2b1d"
import script from "./EffectFields.vue?vue&type=script&lang=js"
export * from "./EffectFields.vue?vue&type=script&lang=js"
import style0 from "./EffectFields.vue?vue&type=style&index=0&id=338c2b1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports